import type { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '../auth/auth-context';

export function ProtectedRoute({ children }: PropsWithChildren) {
  const { session, loading, unavailable } = useAuth();

  if (unavailable) {
    return <p role="alert">Connexion à Supabase indisponible. Vérifie la configuration.</p>;
  }
  if (loading) {
    return null;
  }
  if (!session) {
    return <Navigate to="/connexion" replace />;
  }
  return children;
}
